import React, { useState, useEffect } from 'react';
import { Row, Col, Modal, Button, Spinner } from 'react-bootstrap';
import Table from '../../../../components/Table';

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import moment from 'moment';
import { toast } from 'react-toastify';
import Select from 'react-select';
import {
    createUser,
    updateUser,
    deleteUser,
    getAllUsers,
    getStationNameAPI,
    checkUserIdAPI,
} from '../../../../API/RDPMS_API';
import { addUserColumns, addVendorColumns, sizePerPageList } from '../../../../utils/ColumnUtils';
import * as bootstrap from 'bootstrap';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { getStationForUserAPI } from '../../../../API/RDPMS_API';
import { useSelector } from 'react-redux';
import { Loading } from 'react-loading-ui';
const AddUsers = () => {
    const { t } = useTranslation();
    const [limit, setLimit] = useState(5);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [stations, setStations] = useState([]);

    const [data, setData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showEditUserModal, setShowEditUserModal] = useState(false);
    const [showDeleteUserModal, setShowDeleteUserModal] = useState(false);

    const [userToEdit, setUserToEdit] = useState(null);
    const [userToDelete, setUserToDelete] = useState(null);

    const [userIdStatus, setUserIdStatus] = useState(null);
    const [changePassword, setChangePassword] = useState(false);
    const { auth } = useSelector((state) => {
        const user = state.Auth.user?._j || state.Auth.user;
        return { auth: { ...state.Auth, user } };
    });

    useEffect(() => {
        getAllUserData(limit, pageNumber);
        getStationsList();
    }, []);

    const getStationsList = async () => {
        try {
            const response = await getStationForUserAPI();

            if (response && response.length > 0) {
                setStations(response);
            }
        } catch (err) {
            console.error('Station Fetch Error:', err);
        }
    };

    const getAllUserData = async (limits, pages) => {
        try {
            Loading();

            let limitNumber = limits || limit;
            let pagesNumber = pages || pageNumber;

            let request = {
                limit: limitNumber,
                page: pagesNumber,
                search: '',
            };

            const response = await getAllUsers(request);
            // console.log('USER API RAW RESPONSE:', response);

            if (response && response.data && response.data.length > 0) {
                let dataArray = response.data.map((item) => {
                    return {
                        _id: item._id,

                        name: item.name ?? '-',
                        email: item.email ?? '-',
                        contact: item.contact ?? '-',
                        role: item.role ?? '-',
                        location: item.location ?? '-',

                        station: item.station || [],
                        userId: item.user_id ?? '-',

                        createdAt: moment(item.createdAt).format('Do MMM YYYY, h:mm A'),

                        action: (
                            <div className="d-flex justify-content-center align-items-center gap-3">
                                <Link to="#" className="action-icon" onClick={() => openEditUserModal(item)}>
                                    <i className="mdi mdi-pencil"></i>
                                </Link>

                                <Link
                                    to="#"
                                    className="action-icon text-danger"
                                    onClick={() => openDeleteUserModal(item._id)}>
                                    <i className="mdi mdi-delete"></i>
                                </Link>
                            </div>
                        ),
                    };
                });

                setPageNumber(response.currentPage);
                setPageCount(response.totalPages);
                setData(dataArray);
                setTotalCount(response.totalCount);
                new bootstrap.Modal(document.getElementById('updateUsers')).show();
            } else {
                toast.error('No user data found', {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
        } catch (error) {
            console.error('Error fetching user data:', error);
            toast.error('Failed to refresh user data', {
                position: toast.POSITION.TOP_RIGHT,
            });
        } finally {
            Loading();
        }
    };

    const handlePageChange = async (value) => {
        setPageNumber(1);
        setLimit(value);
        await getAllUserData(value, 1);
    };

    const handlePageClick = async (value) => {
        setPageNumber(value);
        await getAllUserData(limit, value);
    };
    const openEditUserModal = (data) => {
        setUserToEdit(data);
        setShowEditUserModal(true);
    };
    const closeEditUserModal = () => {
        setShowEditUserModal(false);
        resetEditUser();
        setUserToEdit(null);
    };
    const openDeleteUserModal = (id) => {
        setUserToDelete(id);
        setShowDeleteUserModal(true);
    };
    const closeDeleteUserModal = () => {
        setUserToDelete(null);
        setShowDeleteUserModal(false);
    };

    const userSchema = yup.object().shape({
        name: yup.string().required('Name is required'),
        email: yup.string().email('Invalid email').required('Email is required'),
        contact: yup
            .string()
            .matches(/^[0-9]{10}$/, 'Mobile number must be 10 digits')
            .required('Contact is required'),
        location: yup.string().required('Location is required'),
        role: yup.string().required('Role is required'),
        station: yup.array().min(1, 'Select at least one station').required('Station is required'),
        userId: yup
            .string()
            .required('User ID is required')
            .min(6, 'User ID must be at least 6 characters')
            .matches(/[A-Z]/, 'User ID must contain at least one uppercase letter'),

        password: yup
            .string()
            .required('Password is required')
            .min(8, 'Password must be at least 8 characters')
            .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
            .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
            .matches(/[0-9]/, 'Password must contain at least one number')
            .matches(/[@$!%*?&]/, 'Password must contain at least one special character'),
    });

    const {
        register,
        handleSubmit,
        reset,
        setValue,
        formState: { errors },
        setError,
        clearErrors,
    } = useForm({ resolver: yupResolver(userSchema) });

    const openModalWithHeaderClass = () => {
        setShowModal(true);
    };
    const closeModalWithHeaderClass = () => {
        setShowModal(false);
        reset();
    };
    const editUserSchema = yup.object().shape({
        name: yup.string().required(),
        email: yup.string().email().required(),
        contact: yup
            .string()
            .matches(/^[0-9]{10}$/)
            .required(),
        location: yup.string().required(),
        role: yup.string().required(),
        station: yup.array().min(1).required(),
        userId: yup.string().required(),

        password: yup
            .string()
            .transform((v) => (v === '' ? undefined : v))
            .notRequired()
            .min(8)
            .matches(/[A-Z]/)
            .matches(/[a-z]/)
            .matches(/[0-9]/)
            .matches(/[@$!%*?&]/),

        confirmPassword: yup.string().when('password', {
            is: (val) => !!val,
            then: (schema) =>
                schema.required('Confirm password is required').oneOf([yup.ref('password')], 'Passwords do not match'),
            otherwise: (schema) => schema.notRequired(),
        }),
    });

    const {
        register: registerEdit,
        handleSubmit: handleSubmitEdit,
        reset: resetEditUser,
        setValue: setEditValue,
        formState: { errors: editErrors },
    } = useForm({ resolver: yupResolver(editUserSchema) });

    useEffect(() => {
        if (showEditUserModal && userToEdit) {
            setEditValue('name', userToEdit.name || '');
            setEditValue('email', userToEdit.email || '');
            setEditValue('contact', userToEdit.contact || '');
            setEditValue('location', userToEdit.location || '');
            setEditValue('role', userToEdit.role || '');
            setEditValue('station', userToEdit.station?.map((s) => String(s.id)) || []);
            setEditValue('userId', userToEdit.user_id || '');
            setChangePassword(false);
            setEditValue('password', '');
            setEditValue('confirmPassword', '');
        }
    }, [showEditUserModal, userToEdit, setEditValue]);

    const onCreateUser = async (formData) => {
        const mappedStations = stations
            .filter((s) => formData.station.includes(s._id))
            .map((s) => ({
                id: s._id,
                name: s.name,
            }));

        const payload = {
            name: formData.name,
            email: formData.email,
            contact: formData.contact,
            location: formData.location,
            role: formData.role,
            station: mappedStations,
            userId: formData.userId,
            password: formData.password,
        };

        try {
            await createUser(payload);
            toast.success('User Added Successfully');
            closeModalWithHeaderClass();
            getAllUserData();
            setUserIdStatus(null);
        } catch {
            toast.error('Failed to Add User');
        }
    };

    const onUpdateUser = async (formData) => {
        setLoader(true);

        try {
            const stationIds = formData.station.map(String);

            const mappedStations = stations
                .filter((s) => stationIds.includes(String(s._id)))
                .map((s) => ({
                    id: s._id,
                    name: s.name,
                }));

            const payload = {
                name: formData.name,
                email: formData.email,
                contact: formData.contact,
                location: formData.location,
                role: formData.role,
                station: mappedStations,
                user_id: formData.userId,
            };

            if (formData.password) {
                payload.password = formData.password;
            }

            const response = await updateUser(userToEdit._id, payload);

            if (response?.success === false) {
                toast.error(response.message || 'Update failed');
                return;
            }

            toast.success(response.message || 'User updated successfully');
            getAllUserData();
            setShowEditUserModal(false);
            resetEditUser();
        } catch (error) {
            console.error('Update User Error:', error);
            toast.error('Something went wrong');
        } finally {
            setLoader(false);
        }
    };

    const checkUserId = async (userId) => {
        if (!userId) return;

        try {
            let request = {
                id: userId,
            };
            const res = await checkUserIdAPI(request);

            if (res) {
                setError('userId', {
                    type: 'manual',
                    message: 'User ID already exists',
                });
                setUserIdStatus('exists');
            } else {
                clearErrors('userId');
                setUserIdStatus('available');
            }
        } catch (err) {
            console.error(err);
        }
    };

    const onDeleteUser = async () => {
        try {
            await deleteUser(userToDelete);
            toast.success('User Deleted Successfully');
            closeDeleteUserModal();
            getAllUserData();
        } catch {
            toast.error('Failed to Delete User');
        }
    };

    return (
        <div style={{ width: '100%' }}>
            <div className="row mb-3">
                <div className="w-100 d-flex justify-content-between">
                    <div className="col-sm-6">
                        <button className="btn_1">{t('USERS')}</button>
                    </div>

                    <div className="col-sm-6 d-flex justify-content-end">
                        <Button className="export text-black" onClick={openModalWithHeaderClass}>
                            {t('ADD USER')} <i className="fas fa-plus"></i>
                        </Button>

                        <button
                            className="update"
                            id="update"
                            type="button"
                            onClick={() => getAllUserData(limit, pageNumber)}>
                            {t('Update')} <i className="fas fa-sync-alt"></i>
                        </button>
                    </div>
                </div>
            </div>

            <Modal show={showModal} onHide={closeModalWithHeaderClass} centered>
                <Modal.Header closeButton style={{ backgroundColor: '#D9E9FF' }}>
                    <Modal.Title>{t('Add User')}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <form onSubmit={handleSubmit(onCreateUser)}>
                        <div className="mb-3">
                            <label className="form-label">{t('Name')}</label>
                            <input
                                type="text"
                                className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                placeholder="Enter Name"
                                {...register('name')}
                            />
                            {errors.name && <p className="text-danger">{errors.name.message}</p>}
                        </div>

                        <div className="mb-3">
                            <label className="form-label">{t('Email')}</label>
                            <input
                                type="email"
                                className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                placeholder="Enter Email"
                                {...register('email')}
                            />
                            {errors.email && <p className="text-danger">{errors.email.message}</p>}
                        </div>

                        <div className="mb-3">
                            <label className="form-label">{t('Contact')}</label>
                            <input
                                type="text"
                                className={`form-control ${errors.contact ? 'is-invalid' : ''}`}
                                placeholder="Enter Contact Number"
                                {...register('contact')}
                            />
                            {errors.contact && <p className="text-danger">{errors.contact.message}</p>}
                        </div>

                        <div className="mb-3">
                            <label className="form-label">{t('Location')}</label>
                            <input
                                type="text"
                                className={`form-control ${errors.location ? 'is-invalid' : ''}`}
                                placeholder="Enter Location"
                                {...register('location')}
                            />
                            {errors.location && <p className="text-danger">{errors.location.message}</p>}
                        </div>

                        <div className="mb-3">
                            <label className="form-label">{t('Role')}</label>
                            <select className={`form-select ${errors.role ? 'is-invalid' : ''}`} {...register('role')}>
                                <option value="">Select Role</option>
                                <option value="admin">Admin</option>
                                <option value="viewer">Viewer</option>
                            </select>
                            {errors.role && <p className="text-danger">{errors.role.message}</p>}
                        </div>

                        {/* <div className="mb-3">
                            <label className="form-label">{t('Station')}</label>
                            <select
                                multiple
                                className={`form-select ${errors.station ? 'is-invalid' : ''}`}
                                {...register('station')}>
                                {stations.map((st) => (
                                    <option key={st._id} value={st._id}>
                                        {st.name}
                                    </option>
                                ))}
                            </select>
                            {errors.station && <p className="text-danger">{errors.station.message}</p>}
                        </div> */}

                        <div className="mb-3">
                            <Select
                                isMulti
                                placeholder="Select station"
                                options={stations.map((st) => ({
                                    value: st._id,
                                    label: st.name,
                                }))}
                                onChange={(selected) =>
                                    setValue('station', selected ? selected.map((s) => s.value) : [])
                                }
                            />

                            {errors.station && <p className="text-danger">{errors.station.message}</p>}
                        </div>

                        <div className="mb-3">
                            <label className="form-label">{t('User ID')}</label>
                            <input
                                type="text"
                                className={`form-control ${errors.userId ? 'is-invalid' : ''}`}
                                placeholder="Enter User ID"
                                {...register('userId')}
                                onBlur={(e) => checkUserId(e.target.value)}
                            />
                            {errors.userId && <p className="text-danger">{errors.userId.message}</p>}

                            {userIdStatus === 'available' && !errors.userId && (
                                <p className="text-success">User ID is available</p>
                            )}
                        </div>

                        <div className="mb-3">
                            <label className="form-label">{t('Password')}</label>
                            <input
                                type="text"
                                className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                                placeholder="Enter Password"
                                {...register('password')}
                            />
                            {errors.password && <p className="text-danger">{errors.password.message}</p>}
                        </div>

                        <div className="d-flex justify-content-end">
                            <button
                                type="submit"
                                className="btn btn-submit"
                                style={{
                                    backgroundColor: '#F9B74C',
                                    width: '200px',
                                    borderRadius: '0%',
                                    border: 'none',
                                }}
                                disabled={loader}>
                                {loader ? (
                                    <>
                                        <Spinner as="span" animation="grow" size="sm" /> Loading
                                    </>
                                ) : (
                                    <>
                                        <i className="mdi mdi-login"></i> {t('Submit')}
                                    </>
                                )}
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>

            <Modal show={showEditUserModal} onHide={closeEditUserModal} centered>
                <Modal.Header closeButton style={{ backgroundColor: '#D9E9FF' }}>
                    <Modal.Title>{t('Edit User')}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <form onSubmit={handleSubmitEdit(onUpdateUser, (err) => console.log('FORM ERRORS', err))}>
                        <div className="mb-2">
                            <label>{t('Name')}</label>
                            <input className="form-control" {...registerEdit('name')} />
                            <p className="text-danger">{editErrors.name?.message}</p>
                        </div>

                        <div className="mb-2">
                            <label>{t('Email')}</label>
                            <input className="form-control" {...registerEdit('email')} />
                            <p className="text-danger">{editErrors.email?.message}</p>
                        </div>

                        <div className="mb-2">
                            <label>{t('Contact')}</label>
                            <input className="form-control" {...registerEdit('contact')} />
                            <p className="text-danger">{editErrors.contact?.message}</p>
                        </div>

                        <div className="mb-2">
                            <label>{t('Location')}</label>
                            <input className="form-control" {...registerEdit('location')} />
                            <p className="text-danger">{editErrors.location?.message}</p>
                        </div>

                        <div className="mb-2">
                            <label>{t('Role')}</label>
                            <select className="form-select" {...registerEdit('role')}>
                                <option value="">Select</option>
                                <option value="admin">Admin</option>
                                <option value="viewer">Viewer</option>
                            </select>
                            <p className="text-danger">{editErrors.role?.message}</p>
                        </div>

                        <div className="mb-2">
                            <label>{t('Station')}</label>
                            <select multiple className="form-select" {...registerEdit('station')}>
                                {stations.map((st) => (
                                    <option key={st._id} value={st._id}>
                                        {st.name}
                                    </option>
                                ))}
                            </select>
                            <p className="text-danger">{editErrors.station?.message}</p>
                        </div>

                        <div className="mb-2">
                            <label>{t('User ID')}</label>
                            <input className="form-control" {...registerEdit('userId')} />
                            <p className="text-danger">{editErrors.userId?.message}</p>
                        </div>

                        <div className="form-check mb-3">
                            <input
                                type="checkbox"
                                className="form-check-input"
                                id="changePassword"
                                checked={changePassword}
                                onChange={(e) => {
                                    setChangePassword(e.target.checked);
                                    if (!e.target.checked) {
                                        setEditValue('password', '');
                                        setEditValue('confirmPassword', '');
                                    }
                                }}
                            />
                            <label className="form-check-label" htmlFor="changePassword">
                                Change Password
                            </label>
                        </div>

                        {changePassword && (
                            <>
                                <div className="mb-2">
                                    <label>New Password</label>
                                    <input type="password" className="form-control" {...registerEdit('password')} />
                                    <p className="text-danger">{editErrors.password?.message}</p>
                                </div>

                                <div className="mb-2">
                                    <label>Confirm Password</label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        {...registerEdit('confirmPassword')}
                                    />
                                    <p className="text-danger">{editErrors.confirmPassword?.message}</p>
                                </div>
                            </>
                        )}

                        <div className="text-end">
                            <button className="btn btn-warning" type="submit">
                                {t('Update')}
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>

            <div className="modal fade" id="updateUsers" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header close">
                            <button type="button" className="btn-close ms-auto" data-bs-dismiss="modal"></button>
                        </div>
                        <div className="modal-body text-center">
                            <img
                                src="/asset-images/checkmark.png"
                                alt="Success"
                                className="img-fluid"
                                style={{ maxWidth: '100px' }}
                            />
                            <p className="mt-3">{t('User data refreshed successfully')}</p>
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={showDeleteUserModal} onHide={closeDeleteUserModal} centered>
                <Modal.Header closeButton style={{ backgroundColor: '#D9E9FF' }}>
                    <Modal.Title>{t('Delete User')}</Modal.Title>
                </Modal.Header>

                <Modal.Body className="text-center">
                    <img
                        src="/asset-images/deleteiconmodal.png"
                        alt="Delete"
                        className="img-fluid"
                        style={{ maxWidth: '100px' }}
                    />

                    <p className="mt-3">{t('Are you sure you want to delete this user')}?</p>

                    <div className="d-flex justify-content-center gap-2">
                        <Button
                            variant="secondary"
                            onClick={closeDeleteUserModal}
                            style={{ width: '100px', borderRadius: '0' }}>
                            No
                        </Button>

                        <Button
                            variant="outline-danger"
                            onClick={onDeleteUser}
                            style={{
                                width: '100px',
                                borderRadius: '0',
                                border: '2px solid red',
                            }}>
                            Yes
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>

            <div
                className="col-6 col-sm-6 card-add-station p-3 border-0 text-start no-radius my-2"
                style={{
                    width: '100%',
                    boxShadow: '0px 0px 35px rgba(154, 161, 171, 0.15)',
                }}>
                <div className="station-table-wrapper">
                    <Table
                        columns={addUserColumns(t)}
                        data={data}
                        pageSize={limit}
                        pageCount={pageCount}
                        pageNumber={pageNumber}
                        totalCount={totalCount}
                        sizePerPageList={sizePerPageList}
                        isSortable={true}
                        pagination={true}
                        isSearchable={true}
                        onPageChange={handlePageChange}
                        onPageClick={handlePageClick}
                    />
                </div>
            </div>
        </div>
    );
};

export default AddUsers;
